<template>
  <div>
    <slot :openDialog="openDialog">
      <v-text-field
          v-if="!!value"
          :value="value[nameKey]"
          dense
          outlined
          readonly
          :clearable="!readonly"
          :readonly="readonly"
          :label="label"
          @click="dialogChoice=!readonly"
          @click:clear="$emit('input', null)"
          :filled="filled"
          :error="error"
          :error-messages="error_message"
      >
      </v-text-field>
      <v-text-field
          v-else
          :value="null"
          dense
          outlined
          readonly
          :clearable="!readonly"
          :readonly="readonly"
          :label="label"
          @click="dialogChoice=!readonly"
          :error="error"
          :error-messages="error_message"
      >
      </v-text-field>
    </slot>
    <v-dialog
        v-model="dialogChoice"
    >
      <v-sheet>
        <component
            v-if="!!tableComponentPath"
            :is="componentTable"
            :modalDialog.sync="dialogChoice"
            :subtract-height="subtractHeight"
            :only-select="true"
            :show-selected="false"
            :single-select="singleSelect"
            :actionSelected="true"
            @choice="onChoice($event)"
            @click:row="onClickRow"
        ></component>
      </v-sheet>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'BaseDialogSelectFromTable',
  inheritAttrs: false,
  props: {
    value: {default: false},
    nameKey: {default: 'name'},
    subtractHeight: {type: [Number], default: 140},
    readonly: {default: false},
    singleSelect: {default: true},
    tableComponentPath: {type: [String], default: null},
    label: {default: null},
    filled: {default: false},
    property_state: {default: null},
    property_state_field_name: {default: null},
  },

  components: {
    'add-component': () => import(self.tableComponentPath),
  },

  computed: {
    componentTable: function () {
      if (this.tableComponentPath) {
        return () => import("@/components" + this.tableComponentPath);
      }
    },
    error() {
      return !!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error
    },
    error_message() {
      if (!!!!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error)
        return this.property_state[this.property_state_field_name].error_message
      else
        return null
    },
  },

  methods: {
    openDialog() {
      this.dialogChoice = true
    },
    onClickRow(item) {
      // console.log('onClickRow', item)
      if (this.singleSelect === false)
        return
      this.onChoice([item])
    },
    onChoice(selectedItemList) {
      // console.log('onChoice', selectedItemList)
      this.dialogChoice = false
      if (selectedItemList === null || selectedItemList.length === 0)
        return
      if (this.singleSelect) {
        this.$emit('input', selectedItemList[0])
        this.$emit('choice', selectedItemList[0])
      } else {
        this.$emit('input', selectedItemList)
        this.$emit('choice', selectedItemList)
      }
    },
  },

  async mounted() {
  },

  data() {
    return {
      self: this,
      dialogChoice: false,
    }
  }
}
</script>

<style scoped lang="scss">
</style>
